/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, shape } from "prop-types";
import { Formik } from "formik";
import {  Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { push } from "connected-react-router";

const DirectDebitConfirm = (props) => {
    const { isDesktop, fetching, documentToConfirm, fileId } = props;
    const [requestBody, setRequestBody] = useState(false);
    const dispatch = useDispatch();

    const FORM_ID = "directDebit.confirm";

    const onBack = () => {
        if (documentToConfirm?.idTransaction)
            dispatch(push(`/directDebit/transaction/${documentToConfirm?.idTransaction}`));
        else  {
            dispatch(push("/directDebit",  { isConfirm: true, tab: 0}));
       }
    };

    useEffect(() => {
         setRequestBody({
            idTransaction: documentToConfirm?.idTransaction,
            fileName:  documentToConfirm?.fileName,
            fileId: fileId,
        });
 
    }, []);
    
    return (
        <>
            <Notification scopeToShow="DirectDebitConfirm" />
            <ResponsiveHeader
                id={`directDebit.title`}
                onClickBack={onBack}
                defaultTitle={i18n.get(`directDebit.title`)}
            />
            <MainContainer >
                 <h2>{i18n.get(`${FORM_ID}.title`)}</h2>
                <GridTable className="form-summary grid-table-form">
                    <GridTable.Container>
                        <GridTable.Data columnStart={1} rowStart={1} >
                             <CustomData
                                    titleText={i18n.get(`${FORM_ID}.date.label`)}
                                    titleTextType="TEXT"
                                    valueTextType="TEXT"
                                    valueText={documentToConfirm?.date}
                                />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 2 : 1}
                            rowStart={isDesktop ? 1 : 2}
                            >
                             <CustomData
                                    titleText={i18n.get(`${FORM_ID}.fileName.label`)}
                                    titleTextType="TEXT"
                                    valueTextType="TEXT"
                                    valueText={documentToConfirm?.fileName}
                                />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>

                <Formik
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                        termAndConditions: false,
                    }}
                    >
                    {() => (
                        <>
                            <Row>
                                <GeneralCredentialForm
                                    transactionData={requestBody}
                                    type="otp"
                                    action={accountsActions.directDebitSend}
                                    idActivity="directdebit.send"
                                    hideIndications
                                />
                            </Row>
                            </>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

DirectDebitConfirm.propTypes = {
    isDesktop: bool.isRequired,
    servicePaymentData: shape({}).isRequired,
    fetching: bool.isRequired,
};
const mapStateToProps = (state) => ({
    documentToConfirm: accountsSelectors.getDocumentToConfirm(state),
    fileId: accountsSelectors.getDirectDebitFileId(state),
});
export default connect(mapStateToProps)(DirectDebitConfirm);


